import { Text } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

/** "A", "A and B", "A, B and C" — British English, no serial comma. */
const listGrantNames = (names: string[]) => {
  if (names.length <= 1) return names.join('');
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

/**
 * The Customer is shown the effective schedule, which overlays the grants onto
 * the stored one the Provider edits. Nothing else on either surface names that
 * difference, so a Provider reading a gross deposit against a reduced total
 * payable has no way to tell the two apart.
 */
const GrantScheduleNote: FC<{ grantNames: string[] }> = (props) => {
  const { grantNames } = props;

  return (
    <div className="flex items-start gap-2">
      <UntitledIcon
        name="info-circle.3"
        className="mt-0.5 size-4 shrink-0 text-gray-500"
        aria-hidden
      />
      <Text level="supporting">
        This schedule is the full price, before any grant. The customer's
        document shows it with {listGrantNames(grantNames)} applied:{' '}
        {grantNames.length === 1 ? 'the grant is' : 'each grant is'} added as
        its own stage at the end, and the stages above are reduced from the last
        one backwards.
      </Text>
    </div>
  );
};

export default GrantScheduleNote;
